import qs from 'querystring';
import Api from '../lib/request';
import CONSTANT from '../constant/cookie';
import _ from 'underscore';
import cookie from '../lib/cookie';

/**
 * 获取指定企业专区商品信息
 * @param {object} params 请求参数
 */
const getCompanyAreaProductInfo = params => {
  return new Promise((resolve, reject) => {
    const url = `${CONSTANT.REQUEST_HOST}?${qs.stringify(params)}`;
    Api.get(url, {
      headers: {
        'X-Host': 'mall.act.company-area.product-info',
        'X-Token': cookie(CONSTANT.COOKIE_USER_X_TOKEN)
      }
    }).then(
      data => {
        if (data.status === 0) {
          return resolve(data.data);
        }
        return reject(data);
      },
      e => {
        reject(e);
      }
    );
  });
};

export default {
  getCompanyAreaProductInfo
};
